
export default {
  name: 'VsListItem',
  inheritAttrs: false,
  props: {
    index: {
      type: Number,
      default: 0
    },
    animation: {
      type: String,
      default: 'fade'
    },
    lazy: {
      type: Boolean,
      default: false
    },
    duration: {
      type: String,
      default: 'faster'
    }
  },
  data() {
    return {
      visible: !this.lazy
    }
  },
  methods: {
    onLoad() {
      this.$emit('loaded', this)
    }
  },
  mounted() {
    this.$emit('inserted', this)
  },
  beforeDestroy() {
    this.$emit('removed', this)
  }
}
